import GlobalView from '../../pages/GlobalView';
import CoverageProfilePage from '../../pages/UserInformationPage';
import ScenariosPage from '../../pages/ScenariosPage';
import MarketsTechnicalAnalysisPage from '../../pages/MarketsTechnicalAnalysisPage';
import MarketsFundamentalAnalysis from '../../pages/MarketsFundamentalAnalysis';
import HistoricalDataPage from '../../pages/HistoricalDataPage';
import IntradayDollarInfoPage from '../../pages/IntradayDollarInfoPage';
import InputsPage from '../../pages/InputsPage';
import CurrentPositionPage from '../../pages/CurrentPositionPage';
import RiskComparison from '../../pages/RiskComparison';
import BandPositionPage from '../../pages/BandPositionPage';
import BandComparisonPage from '../../pages/BandComparisonPage';
import ReportsPage from '../../pages/ReportsPage';
import CoveragesGridPage from '../../pages/CoveragesGridPage';
import CalculatorPage from '../../pages/CalculatorPage';
import AdminDashboardPage from '../../pages/AdminDashboardPage';
import UserProfilePage from '../../pages/UserProfilePage';
import ForwardAssessmentPage from '../../pages/ForwardAssessmentPage';
import OptionAssessmentPage from '../../pages/OptionsAssessmentPage';
import GridPage from '../../pages/GridPage';
import MobileGlobalView from '../../pagesMobile/MobileGlobalView';
import MobileCalculatorPage from '../../pagesMobile/MobileCalculatorPage';
import MobileForwardAssessmentPage from '../../pagesMobile/MobileForwardAssessmentPage';
import MobileScenariosPage from '../../pagesMobile/MobileScenariosPage';
import MobileRiskComparisonPage from '../../pagesMobile/MobileRiskComparison';
import MobileCoveragesGridPage from '../../pagesMobile/MobileCoveragesGridPage';
import MobileReportsPage from '../../pagesMobile/MobileReportsPage';
import MobileMarketsTechnicalAnalysisPage from '../../pagesMobile/MobileMarketsTechnicalAnalysisPage';
import MobileMarketsFundamentalAnalysis from '../../pagesMobile/MobileMarketsFundamentalAnalysis';
import MobileIntradayDollarInfoPage from '../../pagesMobile/MobileIntradayDollarInfoPage';
import MobileMarketsOrionOverview from '../../pagesMobile/MobileMarketsOrionOverview';
import MobileCurrentPositionPage from '../../pagesMobile/MobileCurrentPositionPage';
import * as con from '../../GlobalConstants'


  // Uses a function through switch to render
export function DesktopPageRenderer({ page }) {
    switch (page) {
      case con.PAGE_START:
        return (<GlobalView />)
      case con.PAGE_COVERAGE_PROFILE:
        return (<CoverageProfilePage />)
      case con.PAGE_SCENARIOS:
        return (<ScenariosPage />)
      case con.PAGE_MARKETS_TECHNICAL_ANALYSIS:
        return (<MarketsTechnicalAnalysisPage />)
      case con.PAGE_MARKETS_FUNDAMENTAL_ANALYSIS:
        return (<MarketsFundamentalAnalysis />)
      case con.PAGE_HISTORICAL_DATA:
        return (<HistoricalDataPage />);
      case con.PAGE_INTRADAY_DOLLAR_INFO:
        return (<IntradayDollarInfoPage />);
      case con.PAGE_INPUTS:
        return (<InputsPage />)
      case con.PAGE_CURRENT_POSITION:
        return (<CurrentPositionPage />)
      case con.PAGE_RISK_COMPARISON:
        return (<RiskComparison />)
      case con.PAGE_BAND_POSITION:
        return (<BandPositionPage />)
      case con.PAGE_BAND_COMPARISON:
        return (<BandComparisonPage />)
      case con.PAGE_GRID:
        return(<GridPage/>)
      case con.PAGE_FORWARD_ASSESSMENT:
        return (<ForwardAssessmentPage />)
      case con.PAGE_OPTION_ASSESSMENT:
        return (<OptionAssessmentPage />)
      case con.PAGE_CALCULATOR:
        return (<CalculatorPage />)
      case con.PAGE_REPORTS:
        return (<ReportsPage />)
      case con.PAGE_COVERAGES_GRID:
        return (<CoveragesGridPage />)
      case con.PAGE_ADMIN_DASHBOARD:
        return (<AdminDashboardPage />)
      case con.PAGE_USER_PROFILE:
        return (<UserProfilePage />)
      default:
        return (<GlobalView />);
    }
  }
  // Uses a function through switch to render
export function MobilePageRenderer({ page }) {

    switch (page) {
      case con.PAGE_START:
        return (<MobileGlobalView />)
      case con.PAGE_CALCULATOR:
        return (<MobileCalculatorPage />)
      case con.PAGE_FORWARD_ASSESSMENT:
        return (<MobileForwardAssessmentPage />)
      case con.PAGE_SCENARIOS:
        return (<MobileScenariosPage />)
      case con.PAGE_RISK_COMPARISON:
        return (<MobileRiskComparisonPage />)
      case con.PAGE_COVERAGES_GRID:
        return (<MobileCoveragesGridPage />)
      case con.PAGE_REPORTS:
        return (<MobileReportsPage />)
      case con.PAGE_MARKETS_TECHNICAL_ANALYSIS:
        return (<MobileMarketsTechnicalAnalysisPage />)
      case con.PAGE_MARKETS_FUNDAMENTAL_ANALYSIS:
        return (<MobileMarketsFundamentalAnalysis />)
      case con.PAGE_HISTORICAL_DATA:
        return (<HistoricalDataPage />);
      case con.PAGE_INTRADAY_DOLLAR_INFO:
        return (<MobileIntradayDollarInfoPage />);
      case con.PAGE_MARKET_ORION_OVERVIEW:
        return (<MobileMarketsOrionOverview />)
      case con.PAGE_CURRENT_POSITION:
        return (<MobileCurrentPositionPage />)
      default:
        return (<MobileGlobalView />);
    }
  }